(function() {
  // Get current script at top level
  const currentScript = document.currentScript;
  const parentSelector = currentScript.dataset.parentSelector;

  document.addEventListener('DOMContentLoaded', function() {
    function toggleElements(currentEl, newEl) {
      currentEl.classList.remove('current');
      newEl.classList.add('current');
    }

    function handleClick(event) {
      const target = event.target.closest('button');
      if (!target) return;

      const tabIndex = target.dataset.tab;

      const subtitleCurrent = document.querySelector(`${parentSelector} .collection-tabs__subtitle > div.current`);
      const subtitleToUpdate = document.querySelector(`${parentSelector} .collection-tabs__subtitle > div.tab-subtitle-${tabIndex}`);
      
      toggleElements(subtitleCurrent, subtitleToUpdate);

      const buttonCurrent = document.querySelector(`${parentSelector} .collection-tabs__button-wrapper > a.current`);
      const buttonToUpdate = document.querySelector(`${parentSelector} .collection-tabs__button-wrapper > a.tab-button-${tabIndex}`);
      toggleElements(buttonCurrent, buttonToUpdate);
    }

    function init() {
      // const prev = document.querySelector(`${parentSelector} button[data-tab="0"]`);
      // const next = document.querySelector(`${parentSelector} button[data-tab="1"]`);
      // prev.addEventListener('click', handleClick);
      // next.addEventListener('click', handleClick);
      const buttons = document.querySelectorAll(`${parentSelector} button[data-tab]`);
      buttons.forEach(button => {
        button.addEventListener('click', handleClick);
      });
    }

    init();
  });
})();